import React, { HTMLAttributes, useState, useMemo, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { Dropdown, List, type DropDownProps } from "antd";
import VirtualList from "rc-virtual-list";

import XtBtntxt from "@/components/Xt/BtnTxt";
import { useRef } from "react";
import XtSvg from "@/components/Xt/Svg";
import OverflowTip from "../OverflowTip";
import { deepClone } from "@/utils/method";
export type ListItemProps<T = ObjAny> = {
  [P in keyof T]: T[P];
} & {
  dropKey: string | number;
  dropName: string;
  dropAvatar?: React.ReactNode;
  dropTitle?: React.ReactNode;
  dropDesc?: React.ReactNode;
  meta?: boolean;
};
interface DropdownBtnProps extends Omit<HTMLAttributes<HTMLDivElement>, "onChange" | "children">, Omit<DropDownProps, "getPopupContainer" | "children"> {
  attr?: any;
  /**存在则有搜索框 */
  search?: { placeholder?: string } | boolean;
  /**面板类名 */
  overlayCls?: string;
  list?: ListItemProps[];
  /**是否开启虚拟列表 */
  virtual?: boolean;
  /** 超出显示省略号并tooltip */
  overflowTip?: boolean;
  /**当前激活哪个，对应list的key */
  value?: string | number;
  getPopupContainer?: boolean | string | ((triggerNode: HTMLElement) => HTMLElement);
  searchIcon?: React.ReactNode;
  searchIconPosition?: "start" | "end";
  clearIcon?: React.ReactNode;
  /**下拉选择 */
  onChange?(key: string | number, item: ListItemProps): void;
  label?: RcNodeType<ListItemProps>;
  defaultLabel?: React.ReactNode;
  dropListPannel?: RcNodeType<{ list: ListItemProps[]; value: string | number; onClick: DropdownBtnProps["onChange"] }>;
  extend?: React.ReactNode;
  children?: RcNodeType<boolean>;
}
const { useTranslation } = Hooks;
const dftList = [];
const dftTrigger: DropDownProps["trigger"] = ["click"];
const DropdownBtn: React.FC<DropdownBtnProps> = ({
  className,
  trigger = dftTrigger,
  search,
  overlayCls,
  value = "",
  virtual = false,
  overflowTip = false,
  list = dftList,
  getPopupContainer,
  searchIcon,
  searchIconPosition = "start",
  clearIcon,
  label,
  defaultLabel = "",
  dropListPannel,
  placement,
  onChange,
  extend,
  children,
  ...rest
}) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const iptRef = useRef<HTMLInputElement>(null);
  const [visible, setVisible] = useState(false);
  const [keyword, setKeyword] = useState("");
  /**useMemo */
  const toGetPopupContainer = useMemo(() => {
    if (getPopupContainer === "body") return undefined;
    if (typeof getPopupContainer === "function") return getPopupContainer;
    return (el: HTMLElement) => el;
  }, []);

  const curListItem = useMemo(() => {
    if (value === undefined || value === null) return;
    const item = list.find((obj) => obj.dropKey === value);
    return item;
  }, [value, list]);

  const getLabel = useMemo(() => {
    if (label) {
      if (typeof label === "function") {
        return label(curListItem);
      }
      return label;
    }
    const name = curListItem ? curListItem.dropName : defaultLabel || "";
    const el = <div style={{ width: "calc(100% - 8px)" }}>{overflowTip ? <OverflowTip value={name as string} /> : (name as React.ReactNode)}</div>;
    return el;
  }, [curListItem, label, overflowTip]);

  const getList = useMemo(() => {
    if (!keyword) return list;
    const ary: ListItemProps[] = [];
    console.log(list, "list");
    list.forEach((item) => {
      if (!item.dropKey) return ary.push(item);
      if (item.dropKey.toString().includes(keyword) || item.dropName.toString().includes(keyword)) ary.push(item);
    });
    return ary;
  }, [keyword, list]);

  const menuMinWidth = useMemo(() => {
    const testEls = document.querySelectorAll(".test-drop-item-len");
    if (testEls.length) {
      for (let i = testEls.length - 1; i >= 0; i--) {
        document.body.removeChild(testEls[i]);
      }
    }
    if (overflowTip) return "260px";
    const nameLens = list.map((item) => item.dropName.length);
    const maxLenItem = Math.max(...nameLens);
    const maxItem = list.find((item) => item.dropName.length === maxLenItem);
    const span = document.createElement("span");
    span.textContent = maxItem?.dropName || "";
    span.classList.add("test-drop-item-len");
    span.style.position = "absolute";
    span.style.left = "-1000px";
    span.style.zIndex = "-100";
    span.style.visibility = "hidden";
    document.body.appendChild(span);
    return (span.offsetWidth + 2 || 260) + "px";
  }, [list, overflowTip]);

  /**method */

  const onInput = (e) => {
    setKeyword(e.target.value);
  };

  const handleClickItem = (key: string | number, item: ListItemProps) => {
    setVisible(false);
    if (key !== value) {
      onChange && onChange(key, item);
    }
  };
  return (
    <Dropdown
      className={className}
      overlayClassName={cx(styles["dropdown-menu-ctn"], overlayCls)}
      overlayStyle={{ width: overflowTip ? "100%" : "" }}
      trigger={trigger}
      getPopupContainer={toGetPopupContainer}
      placement={placement}
      open={visible}
      onOpenChange={(open) => {
        setVisible(open);
      }}
      dropdownRender={(originNode) => (
        <div className={cx("ant-dropdown-menu", styles["xt4-dropdown-menu"])} style={{ minWidth: menuMinWidth }}>
          {search && (
            <div className={"iSearch"}>
              <div>
                {searchIconPosition == "start" && (searchIcon || <XtSvg style={{ color: "#cdd1de" }} src={require("@/assets/icon-svg/xt/search.svg")}></XtSvg>)}
                <input
                  type="text"
                  ref={iptRef}
                  value={keyword}
                  placeholder={typeof search === "boolean" || !search.placeholder ? t("app.search") : search.placeholder}
                  onKeyUp={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onInput={(e) => {
                    onInput(e);
                  }}
                />
                {searchIconPosition == "end" &&
                  !keyword &&
                  (searchIcon || <XtSvg style={{ color: "#cdd1de" }} src={require("@/assets/icon-svg/xt/search.svg")}></XtSvg>)}
                {keyword && (
                  <XtBtntxt
                    onClick={(e) => {
                      e.stopPropagation;
                      setKeyword("");
                    }}
                  >
                    {clearIcon || <XtSvg src={require(`@/assets/icon-svg/xt/close-round.svg`)} width={15} height={15} />}
                  </XtBtntxt>
                )}

                <div
                  onClick={(e) => {
                    e.stopPropagation;
                    iptRef.current?.focus();
                  }}
                ></div>
              </div>
            </div>
          )}

          {!dropListPannel ? (
            virtual ? (
              <List split={false}>
                <VirtualList data={getList.filter((lit) => lit.dropKey != "FUTURES_ALL")} height={260} itemKey={"dropKey"} itemHeight={40}>
                  {(item: ListItemProps) => (
                    <List.Item key={item.dropKey} className={cx(value === item.dropKey && "atv")} onClick={(e) => handleClickItem(item.dropKey, item)}>
                      {item.meta && <List.Item.Meta avatar={item.dropAvatar} title={item.dropTitle} description={item.dropDesc} />}
                      <div
                        key={item.dropKey}
                        style={{ width: "100%", overflow: "hidden" }}
                        className={cx(false && "ant-dropdown-menu-item", value === item.dropKey && "atv")}
                      >
                        {overflowTip ? <OverflowTip value={item.dropName} /> : item.dropName}
                      </div>
                    </List.Item>
                  )}
                </VirtualList>
              </List>
            ) : (
              <div className={"drop-list-ctn"}>
                <List
                  split={false}
                  dataSource={getList.filter((lit) => lit.dropKey != "FUTURES_ALL")}
                  renderItem={(item) => (
                    <List.Item key={item.dropKey} className={cx(value === item.dropKey && "atv")} onClick={(e) => handleClickItem(item.dropKey, item)}>
                      {item.meta && <List.Item.Meta avatar={item.dropAvatar} title={item.dropTitle} description={item.dropDesc} />}
                      <div
                        key={item.dropKey}
                        style={{ width: "100%", overflow: "hidden" }}
                        className={cx(false && "ant-dropdown-menu-item", value === item.dropKey && "atv")}
                      >
                        {overflowTip ? <OverflowTip value={item.dropName} /> : item.dropName}
                      </div>
                    </List.Item>
                  )}
                />
              </div>
            )
          ) : typeof dropListPannel === "function" ? (
            dropListPannel({ list: getList, value, onClick: handleClickItem })
          ) : (
            dropListPannel
          )}

          {extend}
        </div>
      )}
      {...rest}
    >
      {!children ? (
        <XtBtntxt className={cx(styles["xt4-dropdown-trigger"], className, visible && styles["atv"])}>{getLabel}</XtBtntxt>
      ) : typeof children == "function" ? (
        children(visible)
      ) : (
        children
      )}
    </Dropdown>
  );
};
export default observer(DropdownBtn);
